
const {parse} = require('../html')
const {POS_NOUN, POS_VERB, POS_ADJECTIVE} = require('../pos')
const layout = require('./add_analysis.html')

const AnalysisConfig = require('./analysis_config')
const Analysis = require('./analysis')

const AddAnalysis = class {
    constructor(api, document, tokenizers, password) {
        this.api = api
        this.document = document
        this.tokenizers = tokenizers
        this.password = password
        this.onadd = () => {}
    }
    dom() {
        const {api, document, tokenizers, password} = this
        const content = parse(layout, {document, tokenizers}).querySelector('#content')
        const form = content.querySelector('form')
        form.addEventListener('submit', (event) => {
            event.preventDefault()

            const tokenizer = form.querySelector('#tokenizer').value
            const section = parseInt(form.querySelector('#unit-start').value)
            const end = parseInt(form.querySelector('#unit-end').value)
            const limit = end - section + 1
            const split = parseInt(form.querySelector('#unit-split').value)
            const noun = form.querySelector('#pos-noun').checked
            const verb = form.querySelector('#pos-verb').checked
            const adjective = form.querySelector('#pos-adjective').checked
            const pos = []
            if(noun) pos.push(...POS_NOUN)
            if(verb) pos.push(...POS_VERB)
            if(adjective) pos.push(...POS_ADJECTIVE)

            const config = new AnalysisConfig(tokenizer, section, limit, split, pos, password)
            const analysis = new Analysis(api, document, config)

            this.onadd(analysis)

            return true
        })
        return content
    }
}

module.exports = AddAnalysis
